import { render } from "./FormularioCrear.vue?vue&type=template&id=182bf718"
import script from "./FormularioCrear.vue?vue&type=script&lang=js"
export * from "./FormularioCrear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__